import { createTheme } from '@mui/material/styles';

const getDesignTokens = (mode) => ({
  palette: {
    mode,
    ...(mode === 'light'
      ? {
          primary: {
            main: '#0078B7',
            light: '#4FA8D5',
            dark: '#005285',
          },
          secondary: {
            main: '#dc004e',
            light: '#ff5983',
            dark: '#9a0036',
          },
          background: {
            default: '#c2c7ce',
            paper: '#d5d9e0',
          },
          text: {
            primary: '#343B46',
            secondary: '#6F8494',
          },
          divider: 'rgba(0, 120, 183, 0.2)',
          custom: {
            navbarBg: 'linear-gradient(90deg, #0078B7, #4FA8D5)',
            cardBg: '#d5d9e0',
            elevatedCard: '#dee1e6',
            containerBg: '#cdd1d8',
            borderColor: 'rgba(0, 120, 183, 0.3)',
            cardBorder: 'rgba(0, 120, 183, 0.2)',
            chartBg: '#d5d9e0',
            navbarText: '#ffffff',
            success: '#8FC74B',
            warning: '#F59E0B',
            error: '#EF4444',
            info: '#0078B7',
          },
        }
      : {
          primary: {
            main: '#4FA8D5',
            light: '#7FC4E3',
            dark: '#0078B7',
          },
          secondary: {
            main: '#f06292',
            light: '#f48fb1',
            dark: '#c2185b',
          },
          background: {
            default: '#0a0a0a',
            paper: '#141414',
          },
          text: {
            primary: '#ffffff',
            secondary: 'rgba(255, 255, 255, 0.7)',
          },
          custom: {
            navbarBg: 'rgba(18, 18, 18, 0.8)',
            cardBg: 'rgba(20, 20, 20, 0.95)',
            borderColor: 'rgba(255, 255, 255, 0.08)',
            cardBorder: 'rgba(255, 255, 255, 0.06)',
            chartBg: 'rgba(20, 20, 20, 0.9)',
            navbarText: '#ffffff',
            success: '#8FC74B',
            warning: '#ffa726',
            error: '#ef5350',
            info: '#42a5f5',
          },
        }),
  },
  typography: {
    fontFamily: 'Roboto Flex, Arial, sans-serif',
    h4: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 500,
    },
    subtitle1: {
      fontWeight: 500,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1400, // <--- changed from default 1200 to 1400
      xl: 1536,
    },
  },
  spacing: (factor) => `${0.25 * factor}rem`,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollbarColor: mode === 'dark' ? '#6b6b6b #2b2b2b' : '#959595 #f5f5f5',
          '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
            backgroundColor: mode === 'dark' ? '#2b2b2b' : '#f5f5f5',
          },
          '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
            borderRadius: 8,
            backgroundColor: mode === 'dark' ? '#6b6b6b' : '#959595',
            minHeight: 24,
            border: mode === 'dark' ? '3px solid #2b2b2b' : '3px solid #f5f5f5',
          },
          '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
            backgroundColor: mode === 'dark' ? '#959595' : '#6b6b6b',
          },
        },
        ':root': {
          '--header-height': '80px',
          '--lane-header-height': '70px',
          '--lane-padding': '8px',
          '--lane-gap': '8px',
          '--alerts-page-padding': '16px',
          '--workflow-controls-height': '60px',
          '--desktop-min-lane-width': '280px',
          '--monitor-min-lane-width': '320px',
          '--tv-min-lane-width': '400px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor:
            theme.palette.mode === 'light'
              ? theme.palette.custom.cardBg
              : theme.palette.custom.cardBg,
          borderRadius: 12,
          boxShadow:
            theme.palette.mode === 'light'
              ? '0 1px 3px 0 rgba(15, 23, 42, 0.08), 0 1px 2px 0 rgba(15, 23, 42, 0.02)'
              : theme.shadows[1],
          border: `1px solid ${theme.palette.custom.borderColor}`,
        }),
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor:
            theme.palette.mode === 'light'
              ? theme.palette.custom.cardBg
              : theme.palette.custom.cardBg,
          borderRadius: 12,
          boxShadow:
            theme.palette.mode === 'light'
              ? '0 1px 3px 0 rgba(15, 23, 42, 0.08), 0 1px 2px 0 rgba(15, 23, 42, 0.02)'
              : theme.shadows[1],
          border: `1px solid ${theme.palette.custom.borderColor}`,
        }),
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
        },
      },
    },
  },
});

const theme = (mode) => createTheme(getDesignTokens(mode));

export default theme;
